import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { SampleData } from '@/services/spreadsheetService';

interface SampleDataViewerProps {
  sampleData: SampleData | null;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const SampleDataViewer: React.FC<SampleDataViewerProps> = ({ 
  sampleData, 
  isCollapsed, 
  onToggleCollapse 
}) => {
  return (
    <div className={`transition-all duration-300 ${isCollapsed ? 'lg:w-[50px]' : 'lg:w-3/5'}`}>
      <Card className="h-[calc(100vh-200px)] relative">
        <CardHeader className="flex flex-row items-center justify-between">
          {!isCollapsed && (
            <>
              <div>
                <CardTitle>Sample Data</CardTitle>
                <CardDescription>First row items from the spreadsheet</CardDescription>
              </div>
            </>
          )}
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onToggleCollapse}
            className="absolute right-2 top-2"
          >
            {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
          </Button>
        </CardHeader>
        {!isCollapsed && (
          <CardContent>
            <ScrollArea className="h-[calc(100vh-280px)] pr-4">
              {sampleData ? (
                <pre className="bg-gray-100 p-4 rounded-md overflow-x-auto">
                  {JSON.stringify(sampleData.firstRowItems, null, 2)}
                </pre>
              ) : (
                <p className="text-gray-500 text-center p-4">
                  Sample data will appear here after fetching from the spreadsheet
                </p>
              )}
            </ScrollArea>
          </CardContent>
        )}
      </Card>
    </div>
  );
};

export default SampleDataViewer;

